import {atom} from 'recoil';

const loadingState = atom({
  key: 'closed_alerts_table_loading',
  default: true
})

const errorState = atom({
  key: 'closed_alerts_table_error',
  default: false
})

const rowsState = atom({
  key: 'closed_alerts_table_rows',
  default: []
})

const pageState = atom({
  key: 'closed_alerts_table_page',
  default: 1
})

const pageSizeState = atom({
  key: 'closed_alerts_table_page_size',
  default: 10
})

const totalSizeState = atom({
  key: 'closed_alerts_table_total_size',
  default: 0
})


export {
  loadingState,
  errorState,
  rowsState,
  pageState,
  pageSizeState,
  totalSizeState,
}